(function () {
  const CACHE_KEY = 'usd_rate_cache';
  const CACHE_HOURS = 12;
  const MARKUP = 1.00;
  const FALLBACK_RATE = 0.012;

  let cachedRate = null;

  // Server-detected buyer country (set in theme.liquid from Liquid's
  // `localization.country`, which is IP-based and reliable — unlike
  // window.Shopify.country, which just reflects the active market and
  // defaults to the shop's primary market for every visitor until they
  // manually pick a different country from the localization selector).
  function isIndia() {
    return window.ShopifyBuyerCountry === 'IN';
  }

  async function getInrToUsdRate() {
    if (cachedRate) return cachedRate;

    try {
      const cached = JSON.parse(
        localStorage.getItem(CACHE_KEY) || 'null'
      );

      const isFresh =
        cached &&
        (Date.now() - cached.timestamp) <
        CACHE_HOURS * 60 * 60 * 1000;

      if (isFresh) {
        cachedRate = cached.rate;
        return cachedRate;
      }

      const response = await fetch(
        'https://api.frankfurter.dev/v1/latest?base=INR&symbols=USD'
      );

      if (!response.ok) {
        throw new Error('Rate fetch failed');
      }

      const data = await response.json();

      cachedRate = data.rates.USD;

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          rate: cachedRate,
          timestamp: Date.now()
        })
      );

      return cachedRate;

    } catch (error) {
      console.warn(
        'USD price: using fallback rate —',
        error
      );

      cachedRate = FALLBACK_RATE;
      return cachedRate;
    }
  }

  async function convertElement(el) {

    // INDIA = KEEP ORIGINAL INR PRICE
    if (isIndia()) {
      return;
    }

    const inrMinorUnits = parseInt(
      el.dataset.inrPrice,
      10
    );

    if (isNaN(inrMinorUnits)) {
      return;
    }

    const rate = await getInrToUsdRate();

    // Check country again after API response
    if (isIndia()) {
      return;
    }

    const usd =
      (inrMinorUnits / 100) *
      rate *
      MARKUP;

    el.textContent =
      '$' + usd.toFixed(2) + ' USD';

    el.dataset.usdApplied = 'true';
  }

  function convertAll(root = document) {

    if (isIndia()) {
      return;
    }

    root
      .querySelectorAll('[data-inr-price]')
      .forEach(convertElement);
  }

  function init() {

    console.log(
      'Buyer country:',
      window.ShopifyBuyerCountry
    );

    // Initial conversion
    convertAll();

    // Watch for the theme re-rendering the mega menu
    const observer = new MutationObserver((mutations) => {

      if (isIndia()) {
        return;
      }

      mutations.forEach((mutation) => {

        mutation.addedNodes.forEach((node) => {

          if (!(node instanceof Element)) {
            return;
          }

          if (
            node.matches?.('[data-inr-price]')
          ) {
            convertElement(node);
          }

          node
            .querySelectorAll?.('[data-inr-price]')
            .forEach(convertElement);

        });

      });

    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Self-healing safety net: something outside this script (a menu reflow,
  // a section re-render, etc.) may reset the price text back to the
  // server-rendered INR value after we've already converted it. Rather than
  // rely solely on catching that reset via MutationObserver, periodically
  // re-check and re-apply the conversion so the display stays correct no
  // matter what's causing the reset.
  function looksConverted(el) {
    return el.textContent.trim().startsWith('$');
  }

  function healAll() {
    if (isIndia()) return;
    document.querySelectorAll('[data-inr-price]').forEach((el) => {
      if (!looksConverted(el)) {
        convertElement(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  setInterval(healAll, 800);

})();